import {Badge} from 'antd'
import {RoleBadge, UserRole} from 'app/core/_model'
import {Administrator, Cashier, Office, OfficeRestricted, SystemAdministrator} from 'consts/role'
import {vw_application_user} from 'openapi'
import React from 'react'

const styles = {
  indicator: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 4,
    paddingBottom: 3,
    height: 30,
    borderRadius: 3,
    fontSize: 13,
  },
}

export const badge = (key: string, name: string): React.ReactNode => {
  var t: RoleBadge = {
    color: 'volcano',
    role_name: 'System Administrator',
  }

  switch (name) {
    case Cashier.value:
      t.color = 'magenta'
      t.role_name = Cashier.label
      break
    case Office.value:
      t.color = 'blue'
      t.role_name = Office.label
      break
    case SystemAdministrator.value:
      t.color = 'red'
      t.role_name = SystemAdministrator.label
      break
    case Administrator.value:
      t.color = 'volcano'
      t.role_name = Administrator.label
      break
    default:
      t.color = 'volcano'
      break
  }
  return <Badge key={`${key}`} className='me-2 rounded-0' color={t.color} count={t.role_name} styles={styles} />
}

export const getBadgeRole = (data: vw_application_user): React.ReactNode => {
  if (data?.is_sysadmin) {
    return badge(data?.id || '', SystemAdministrator.value)
  }
  if (data?.is_administrator) {
    return badge(data?.id || '', Administrator.value)
  }
  let parsedArray: UserRole[] = []

  if (Array.isArray(data?.teams)) {
    parsedArray = data?.teams as UserRole[]
  } else {
    try {
      parsedArray = JSON.parse(data?.teams ?? '[]')
    } catch (error) {
      return '-'
    }
  }

  if (!Array.isArray(parsedArray) || parsedArray.length === 0) {
    return '-'
  }

  return <>{parsedArray.map((role, _) => badge(`${role?.store_id}${role?.business_area_name}${role?.team}`, role.team))}</>
}

export const isCashier = (data: vw_application_user): boolean => {
  let roles: UserRole[] = []

  if (Array.isArray(data?.teams)) {
    roles = data?.teams as UserRole[]
  } else {
    try {
      roles = JSON.parse(data?.teams ?? '[]')
    } catch (error) {
      return false
    }
  }

  if (roles.length === 0) {
    return false
  }

  return roles.some((role) => role.team === Cashier.value)
}

export const isOffice = (data: vw_application_user): boolean => {
  let roles: UserRole[] = []

  if (Array.isArray(data?.teams)) {
    roles = data?.teams as UserRole[]
  } else {
    try {
      roles = JSON.parse(data?.teams ?? '[]')
    } catch (error) {
      return false
    }
  }

  if (roles.length === 0) {
    return false
  }

  return roles.some((role) => role.team === Office.value)
}

export const isOfficeRestricted = (data: vw_application_user): boolean => {
  let roles: UserRole[] = []

  if (Array.isArray(data?.teams)) {
    roles = data?.teams as UserRole[]
  } else {
    try {
      roles = JSON.parse(data?.teams ?? '[]')
    } catch (error) {
      return false
    }
  }

  if (roles.length === 0) {
    return false
  } else if (roles?.length === 1) {
    return data?.is_restricted ?? false
  }
  return roles.some((role) => role.team === OfficeRestricted.value)
}
